<template>
	<div class="container">
		<home-header class="header" title="专题活动"></home-header>
    <div class="list">
      <home-product-list  v-for="(items,index) in promotionProducts"  :key="index" :items="items" :id="items.id" :title="items.title" :type="popular"></home-product-list>
    </div>
		<back-top v-if="isshowBacktop" :target="target" :bottom="60"></back-top>
	</div>
</template>
<script>
import { Header, Indicator, Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { HeaderItem } from '../../components/common';
import BackTop from '../../components/common/BackTop';
import HomeHeader from './child/HomeHeader';
import HomeProductList from './child/HomeProductList';
import { ENUM } from '../../const/enum';
import { recommendBonusInfo } from '../../api/recommend'

export default {
  name:'promotionList',
  data() {
    return {
      isshowBacktop: false,
      popular: ENUM.SORT_KEY.POPULAR,
      sale: ENUM.SORT_KEY.SALE,
      recently: ENUM.SORT_KEY.DATE,
      shared_link: '',
      page:1
    };
  },
  components: {
    HomeHeader,
    HomeProductList,
    BackTop,
  },
  mounted() {
    this.getfetchPromotionProduct()         
    var element = this.$el;
    var that = this;
    var dom = document.querySelector('.list');    
    if (dom) {
      dom.addEventListener('scroll', event => {
        let params = {
          top: dom.scrollTop,
          height: dom.scrollHeight
        };
        if (params.top >= 100) {
          this.isshowBacktop = true;
        } else {
          this.isshowBacktop = false;
        }
      });
    }
    this.target = document.querySelector('.list');
  },
  activated(){
    this.target = document.querySelector('.list');
    if(this.target){
        this.target.addEventListener('scroll', (event) => {
          if (this.target.scrollTop) {
            this.offsetTop = this.target.scrollTop
          } 
        });
    }
    if(this.offsetTop) this.target.scrollTop = this.offsetTop
  },
  destroyed() {
		console.dir(this.$options)
	},
  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,
      promotionProducts:state => state.promotions.promotionProducts
    }),
  },
  methods: {
    ...mapActions({
      fetchPromotionProduct: 'fetchPromotionProduct',
    }),
    getfetchPromotionProduct(){
      Indicator.open();
      let  display_area = 2
      this.fetchPromotionProduct({display_area:display_area,page:this.page,per_page:100}).then(
        response => {
          Indicator.close();
        },
        error => {
          Indicator.close();
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: auto;
  position: absolute;
  bottom: 0px;
  top: 0px;
  width: 100%;
}
.header {
  background-color: #ffffff;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid $lineColor;
}
.list {
  background-color: #ffffff;
  padding-top:10px;
  position: absolute;
  top: 32px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/promotion-list/promotion.vue